<div class="container mt-4" style="min-width: 720px">
  <h1 class="title-blue-h1-cap" id="assistance-report">
    Visualizaci&oacute;n y registro de asistencia
  </h1>
  <hr />
  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>folder</mat-icon>
        &nbsp;&nbsp; Mi reporte de asistencias
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>share</mat-icon>
        &nbsp;&nbsp; Reporte de asistencias compartidas
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <!-- Buscador -->
  <ng-container *ngIf="spinner">
    <app-loading-spinner></app-loading-spinner>
  </ng-container>
  <div *ngIf="!spinner">
    <mat-card>
      <div class="p-2">
        <!-- session details -->
        <div class="d-flex flex-column-reverse my-2 p-3">
          <div id="details">
            <span
              matTooltip="Selecciona un evento para visualizar los detalles">
              <button
                disabled="{{ detailSessionButton }}"
                (click)="viewDetailsSession()"
                mat-raised-button
                class="mx-2">
                <mat-icon>zoom_in</mat-icon>
                <span>Detalle de la sesi&oacute;n</span>
              </button>
            </span>
          </div>
        </div>
        <div id="SearchRow" class="row d-flex px-3 align-items-end mb-3">
          <!-- select year -->
          <div class="col-lg-6 col-sm-3">
            <app-year-session-selector
              [yearList]="yearList"
              [sessions]="coursesSessions"
              [selectedYear]="selectedYear ?? null"
              [selectedSessionId]="selectedCourseSession?.Id ?? null"
              [isLoadingSessions]="isLoadingSessions"
              [showSessionError]="showSelectCourseError"
              (yearChange)="onChangeYearWrapper($event)"
              (sessionChange)="onSessionChangeWrapper($event)"
              (sessionBlur)="onBlurCourseSelect()">
            </app-year-session-selector>
          </div>

          <!-- select session part -->
          <div
            id="selectSesionDay"
            class="col-lg-3 col-sm-6 d-flex flex-column justify-content-end">
            <label class="form-label title-blue-bimbo-cap"
              >Seleccionar día</label
            >
            <select
              class="form-select"
              [disabled]="!selectedCourseSession"
              [(ngModel)]="selectedSession">
              <option [ngValue]="-1">Todos los días</option>
              <option
                *ngFor="let session of sessions"
                [ngValue]="session.value">
                {{ session.showValue }}
              </option>
            </select>
          </div>
          <!-- main btn -->
          <div class="col-lg-3 col-sm-12 mt-sm-2 mt-lg-0 d-flex gap-2">
            <button
              class="btn btn-primario w-50"
              (click)="loadReport()"
              [disabled]="!selectedCourseSession"
              id="BuscarInfo">
              <span> Ver Asistencia </span>
            </button>
            <button
              ngbTooltip="Integrar asistencias a GB University"
              placement="top"
              [disabled]="!enableActionBtns"
              [class]="
                enableActionBtns
                  ? 'btn btn-secondary-cap w-50'
                  : 'btn btn-secondary w-50'
              "
              (click)="openDuplicatesModal()"
              id="queue-asssitances">
              <ng-container *ngIf="!isQueueAssistancesLoading; else loading">
                Registrar Asistencias
              </ng-container>
              <ng-template #loading>
                <span class="spinner-border spinner-border-sm"></span>
              </ng-template>
            </button>
          </div>
        </div>
      </div>
      <mat-card-content class="px-5">
        <div class="container d-flex my-3">
          <mat-form-field appearance="fill" style="width: 100%" class="mx-2">
            <input
              matInput
              [disabled]="!reporteAsistenciasSessions"
              (keyup.enter)="filterChange($event)"
              placeholder="Buscar" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
          <div class="mx-1">
            <button
              [disabled]="
                !reporteAsistenciasSessions ||
                reporteAsistenciasSessions.participantes.length === 0
              "
              style="border: none; outline: none; background: none"
              (click)="generarReporte()"
              mat-fab
              [disabled]="getIsExcelBtnDisabled"
              [ngStyle]="{
                'background-color': getIsExcelBtnDisabled
                  ? 'lightgray'
                  : 'green',
                color: getIsExcelBtnDisabled ? 'darkgray' : 'white'
              }"
              matTooltip="Exportar a excel"
              style="background-color: green; color: white">
              <mat-icon>download</mat-icon>
            </button>
          </div>
          <div class="mx-1">
            <button
              [disabled]="isAddAttendantBtnDisabled"
              (click)="openAttendanceModal(attendanceModal)"
              mat-fab
              color="primary"
              matTooltip="Agregar asistencia">
              <mat-icon>person_add</mat-icon>
            </button>
          </div>
        </div>
        <div style="width: 100%; overflow-x: auto; min-width: 600px">
          <ng-container *ngIf="isAssistanceLoading; else showData">
            <app-loading-spinner></app-loading-spinner>
          </ng-container>
          <ng-template #showData>
            <ng-container
              *ngIf="
                reporteAsistenciasSessions &&
                  reporteAsistenciasSessions.participantes.length > 0;
                else noData
              ">
              <div
                class="row d-flex align-items-center gap-2"
                *ngIf="showsAllSessionsAttendance">
                <div class="col-auto" *ngIf="showGradeColumn && gradesTouched">
                  <button class="btn btn-primario" (click)="registerGrades()">
                    <ng-container *ngIf="!isLoadingGrades; else loadingGrades">
                      <span>Registrar calificaciones</span>
                    </ng-container>
                  </button>
                </div>
                <div class="col-auto">
                  <button
                    *ngIf="
                      (getOgAttendantsHaveGrades && gradesTouched) ||
                      !getOgAttendantsHaveGrades
                    "
                    [class]="
                      showGradeColumn
                        ? 'btn btn-secondary-cap'
                        : 'btn btn-primario'
                    "
                    (click)="onCancelOrShowGradesEdit()">
                    <span *ngIf="!showGradeColumn">
                      Registrar calificaciones
                    </span>

                    <span *ngIf="showGradeColumn"> Cancelar </span>
                  </button>
                </div>

                <div class="col-auto">
                  <span
                    ngbTooltip="Copiar asistencias a otra sesión"
                    placement="top">
                    <button
                      class="btn btn-secondary-cap"
                      [disabled]="!enableActionBtns"
                      (click)="openDuplicateAttendanceModal()">
                      <ng-container *ngIf="!isLoadingDuplicateAttendance">
                        Copiar asistencias
                      </ng-container>

                      <ng-container *ngIf="isLoadingDuplicateAttendance">
                        <span class="spinner-border spinner-border-sm"></span>
                      </ng-container>
                    </button>
                  </span>
                </div>
              </div>
              <ng-template #loadingGrades>
                <span class="spinner-border spinner-border-sm"></span>
              </ng-template>
              <ng-template #loadingGrades>
                <span class="spinner-border spinner-border-sm"></span>
              </ng-template>
              <div style="min-height: 350px" class="mt-3">
                <table
                  matSort
                  mat-table
                  (matSortChange)="sortData($event)"
                  [dataSource]="dataSource"
                  class="mat-elevation-z8"
                  aria-describedby="assistance-report">
                  <ng-container matColumnDef="code">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Número de Colaborador
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.numeroPersona }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th
                      mat-sort-header
                      mat-header-cell
                      *matHeaderCellDef
                      style="min-width: 150px">
                      Nombre
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ getFullName(element) }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="curp">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      CURP
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.curp ?? "-" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th
                      mat-sort-header
                      mat-header-cell
                      *matHeaderCellDef
                      style="min-width: 150px">
                      Email
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.email ?? "-" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <th
                      mat-sort-header
                      mat-header-cell
                      *matHeaderCellDef
                      style="min-width: 150px">
                      Fecha asistencia
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="min-width: 150px; text-align: center">
                      {{
                        element.fechaRegistro
                          | date: "dd/MM/yyyy" : "" : "es-mx"
                          | titlecase
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="numeroSesion">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Total de asistencias
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="attendance-flex">
                        <span class="attendance-text">
                          {{
                            selectedCourseSession?.QrMeastro
                              ? reporteAsistenciasSessions.numeroTotalPartesSesion
                              : element.numeroSesion ?? "-"
                          }}
                          de
                          {{
                            reporteAsistenciasSessions.numeroTotalPartesSesion
                          }}
                        </span>
                        <button
                          *ngIf="showsAllSessionsAttendance"
                          type="button"
                          mat-icon-button
                          ngbTooltip="Ver detalle"
                          [disabled]="isAttendanceDetailsBtnDisabled(element)"
                          (click)="openOffcanvas(element)">
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="grades" *ngIf="showGradeColumn">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Calificaci&oacute;n
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <input
                        type="number"
                        class="form-control form-control-xs"
                        [disabled]="!showsAllSessionsAttendance"
                        [(ngModel)]="element.calificacion"
                        (change)="onUpdateSingleGrade(element)"
                        max="100"
                        min="0" />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Estatus
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        getStatusInfoByNumber(element.idSesionAsistenciaEstatus)
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="delete">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Eliminar
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <button
                        type="button"
                        mat-icon-button
                        color="warn"
                        ngbTooltip="Eliminar asistencia"
                        [disabled]="isDeleteAttendantBtnDisabled(element)"
                        (click)="onDeleteAttendant(element)">
                        <ng-container
                          *ngIf="
                            deletingAttendant !== element.idAsistencia;
                            else loading
                          ">
                          <span>
                            <mat-icon>delete</mat-icon>
                          </span>
                        </ng-container>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </div>
            </ng-container>
            <ng-template #noData>
              <div
                class="d-flex flex-column align-items-center mb-2 mt-3 text-center"
                *ngIf="errorOnGetAttendance">
                <div>
                  <h3 class="form-text text-danger mt-3">
                    Ha ocurrido un error al cargar los datos
                  </h3>
                </div>
              </div>
              <app-no-data-msg></app-no-data-msg>
            </ng-template>
          </ng-template>
        </div>
      </mat-card-content>

      <br />

      <mat-paginator
        [length]="totalRecords"
        [pageSizeOptions]="[5, 10, 20, 100]"
        [pageSize]="selectedPageSize"
        (page)="onPageSizeChange($event)"
        showFirstLastButtons></mat-paginator>
    </mat-card>
  </div>
  <ng-template #loading>
    <span
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"></span>
    <span class="sr-only">Cargando...</span>
  </ng-template>
</div>

<app-general-empty-modal #modal [modalConfig]="modalConfig">
  <ng-container
    *ngIf="isModalOpen && eventAndSessionData && reporteAsistenciasSessions">
    <app-duplicate-attendees-table
      [eventAndSessionData]="eventAndSessionData"
      [incompleteAttendance]="
        reporteAsistenciasSessions.participantesIncompletos
      "
      (closeModalEmitter)="
        onCloseModal($event)
      "></app-duplicate-attendees-table>
  </ng-container>
</app-general-empty-modal>

<app-general-empty-modal
  #modalDuplicateAttendance
  [modalConfig]="duplicateAttendanceModalConfig">
  <ng-container
    *ngIf="
      isDuplicateAttendanceModalOpen &&
      reporteAsistenciasSessions &&
      selectedCourseSession
    ">
    <app-duplicate-attendance-modal
      [yearList]="yearList"
      [sourceSession]="selectedCourseSession"
      [selectedYear]="selectedYear ?? null"
      (confirm)="onConfirmDuplicateAttendance($event)"
      (cancel)="
        duplicateAttendanceModal.close()
      "></app-duplicate-attendance-modal>
  </ng-container>
</app-general-empty-modal>

<ng-template #attendanceModal>
  <app-modal-register-guest-attendance
    [allowPersonNumber]="true"
    [allowCurp]="false"
    (submitData)="validateDataAndAddAttendant($event)"
    (closeModal)="closeAttendanceModal()"></app-modal-register-guest-attendance>
</ng-template>

<app-off-canvas [options]="offCanvasOptions" #offcanvasAttendanceComponent>
  <ng-container *ngIf="gettingAttendantDetails && eventAndSessionData">
    <app-attendance-parts-detail
      [attendant]="gettingAttendantDetails"
      [totalPartsNumber]="reporteAsistenciasSessions?.numeroTotalPartesSesion"
      [eventAndSessionData]="eventAndSessionData"
      (closeOffCanvasEmitter)="
        onCloseAttendanceDrawer($event)
      "></app-attendance-parts-detail>
  </ng-container>
</app-off-canvas>
